import React from 'react'
import classNames from 'classnames'
import { Type } from '@/components/common'
import { ArrowRight } from '@/components/svg'

export interface Props {
  idx: number
  id?: string
  title?: string
  Component?: () => JSX.Element
  itemsRef: { current: (HTMLElement | null)[] }
}

const ComponentWrap: React.FC<Props> = ({
  idx,
  id,
  itemsRef,
  title,
  Component,
}) => {
  if (!Component) return null

  return (
    <div
      key={id}
      id={id}
      data-title={title}
      ref={(el) => (itemsRef.current[idx] = el)}
      className={classNames(
        'relative mb-6 flex flex-col justify-center bg-core-white px-6 py-8 lg:mx-24 lg:rounded-2xl 2lg:mx-0',
        // only apply style if it's the first section, and it's an overview section
        {
          'first:mb-16 first:bg-transparent first:py-0 lg:first:px-0':
            id?.includes('section-overview'),
        }
      )}
    >
      {idx > 0 && (
        <>
          <ArrowRight className="absolute left-0 top-8 text-core-oxide-600" />
          <Type as="h2" variant="title-lg" className="mb-6 font-bold">
            {title}
          </Type>
        </>
      )}
      <Component />
    </div>
  )
}

export default ComponentWrap
